import React from "react";
import { useSelector } from "react-redux";
import { Switch } from "react-router-dom";
import { PAGE_START, PAGE_LOGIN } from "../constants/routes";
import AppRoutes from "./AppRoutes";
import PublicRoutes from "./PublicRoutes";
import RedirectRoute from "./RedirectRoute";
import { isUserLoggedIn } from "../store/selectors/user";
import useDepotChangeListener from "../hooks/useDepotChangeListener";

const Routes = () => {
  const userLogged = useSelector(isUserLoggedIn);
  useDepotChangeListener();

  return (
    <Switch>
      <RedirectRoute if={!userLogged} to={PAGE_START} path={PAGE_LOGIN}>
        <PublicRoutes />
      </RedirectRoute>
      <RedirectRoute if={userLogged} to={PAGE_LOGIN}>
        <AppRoutes />
      </RedirectRoute>
    </Switch>
  );
};

export default Routes;
